import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

export const Form = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    location: "",
    type: "Call",
    remarks: "",
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (!form.name || !form.phone) {
      return toast.error("Name and Phone number are required");
    }
    setLoading(true);

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/lead/create-lead`,
      maxBodyLength: Infinity,
      data: form,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log("Response of handleSubmit(Lead): ", response.data);
        setLoading(false);
        toast.success("Your query recorded. We'll reach you out soon.");
      })
      .catch((error) => {
        // console.log("Error in handleSubmit: ", error);
        toast.error("Something went wrong. Please try again later.");
        setLoading(false);
      });
  };
  return (
    <div className=" my-8 flex justify-center">
      <div className="w-[95%] md:w-[80%] border-2 border-[#0465B9] p-4 md:py-4 lg:py-6 md:p-8 lg:p-16 flex flex-col justify-center items-center">
        <h1 className="font-bold text-[#0465B9] text-lg md:text-2xl text-center mb-4">
          Contact Form
        </h1>

        <input
          type="text"
          className="py-2 px-4 outline-none border border-[#0465B9] w-full md:w-[80%] lg:w-[70%] rounded-lg my-2"
          placeholder="Your Name"
          value={form.name}
          onChange={(e) =>
            setForm({
              ...form,
              name: e.target.value,
            })
          }
        />

        <input
          type="text"
          className="py-2 px-4 outline-none border border-[#0465B9] w-full md:w-[80%] lg:w-[70%] rounded-lg my-2"
          placeholder="Your Mobile Number"
          value={form.phone}
          onChange={(e) =>
            setForm({
              ...form,
              phone: e.target.value,
            })
          }
        />

        <input
          type="text"
          className="py-2 px-4 outline-none border border-[#0465B9] w-full md:w-[80%] lg:w-[70%] rounded-lg my-2"
          placeholder="Enter Location"
          value={form.location}
          onChange={(e) =>
            setForm({
              ...form,
              location: e.target.value,
            })
          }
        />

        <textarea
          className="py-2 px-4 outline-none border border-[#0465B9] w-full md:w-[80%] lg:w-[70%] rounded-lg my-2 "
          placeholder="Your Message"
          value={form.remarks}
          onChange={(e) =>
            setForm({
              ...form,
              remarks: e.target.value,
            })
          }
        />

        <button
          className="bg-[#0465B9] w-full md:w-auto px-4 py-2 mt-4 text-white rounded md:px-8 lg:px-16 hover:bg-[#05559f]"
          onClick={handleSubmit}
        >
          {loading ? "Sending" : "Send Message"}
        </button>
      </div>
    </div>
  );
};
